import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Lottery from './pages/Lottery';
import Sessions from './pages/Sessions';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lottery/:id" element={<Lottery />} />
          <Route path="/sessions" element={<Sessions />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;